import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { GuidanceService } from 'src/app/services/http/business/guidance/guidance.service';

@Component({
  selector: 'app-guide-tree-search',
  templateUrl: './guide-tree-search.component.html',
  styleUrls: ['./guide-tree-search.component.css']
})
export class GuideTreeSearchComponent implements OnInit {


  form = new FormGroup({
    SearchText: new FormControl(null),
  });

  queryResultList: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GuideTreeSearchComponent>,
    private guideService: GuidanceService,
    private errorService: ErrorsService
  ) { }

  ngOnInit() {
  }

  onQuerySearch()
  {
    const query = {...this.form.value};

    this.guideService.getAllGuideBySearch(query).subscribe({
      next: (res: any) => {
        this.queryResultList = res.DataList;
      },
      error: () => {
        this.errorService.transactionError();
      },
    });
  }

  onQueryResultSelect(id: number)
  {
    const result = {
      Id: id,
    }

    this.dialogRef.close(result)
  }

  onClose()
  {
    this.dialogRef.close();
  }

}
